<template>
  <panel :withFooter="false">
    <loader :loading="loading"/>
    <div class="l-row vertical-center">
      <div class="l-col-10@md">
        <div class="l-row infos">
          <div class="l-col-12@md">
            <strong class="title">
              Dados do seu anúncio:
            </strong>

            <div class="l-row vertical-center">
              <div class="l-col-2@md img-product">
                <img :src="announcementVariation.images[0].url" class="img-rounded"
                     v-if="announcementVariation.images[0].url"/>
                <i class="icon icon-image2 no-photo" v-else></i>
              </div>
              <div class="l-col-10@md">
                <div class="l-row">
                  <div class="l-col-4@md" v-for="attribute in announcementVariationName">
                    <div class="margin">
                      <strong>{{ attribute.label }}:</strong>
                      {{ attribute.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="l-row infos">
          <div class="l-col-12@md">
            <strong class="title">
              Dados do anúncio do marketplace:
            </strong>
            <div class="l-row vertical-center">
              <div class="l-col-2@md img-product">
                <img :src="announcementToMatch.pictures[0].url" class="img-rounded"
                     v-if="announcementToMatch.pictures[0].url"/>
                <i class="icon icon-image2 no-photo" v-else></i>
              </div>
              <div class="l-col-10@md">
                <div class="l-row">
                  <div class="l-col-12@md">
                    <strong class="margin">Título: </strong>
                    {{ announcementToMatch.name }}
                  </div>
                  <div class="l-col-4@md">
                    <div class="margin">
                      <strong>Código:</strong>
                      <a v-if="announcementToMatch.permalink" :href="announcementToMatch.permalink" target="_blank">
                        <span class="hint hint--bottom" data-label="Clique para acessar no marketplace"> {{ announcementToMatch.id }} <i
                            class="icon-new-tab"/></span>
                      </a>
                    </div>
                  </div>
                  <div class="l-col-4@md" v-for="attribute in productToMatchAttributes">
                    <div class="margin">
                      <strong>{{ attribute.label }}:</strong>
                      {{ attribute.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-col-1@md btn-container">
        <div class="l-row">
          <button class="btn" @click="redirectToNewAnnouncement"
                  v-if="match">Visualizar o novo anúncio
          </button>
        </div>
      </div>
      <div class="l-col-1@md btn-container">
        <div class="l-row">
          <button class="btn btn--info" @click="updateAnnouncementToCheckout" :disabled="match"
                  v-if="elegible"
                  v-bind:class="{ 'is-loading': isUpdating }">Match
          </button>
        </div>
      </div>
    </div>
  </panel>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import notifier from '@/notifier'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      elegible: null,
      isUpdating: false,
      announcementToMatch: {},
      match: false,
      loading: false,
      newAnnouncement: {}
    }),
    props: {
      announcementVariation: {
        type: Object,
        required: true
      },
      product: {
        type: Object,
        required: true
      },
      account: {
        type: String,
        required: true
      }
    },
    async mounted () {
      this.loading = true
      const attributeGtin = this.announcementVariation.attributes.find(attribute => attribute.id === 'GTIN')
      try {
        this.announcementToMatch = await api.mercadoLivre.retrieveVariationElegibleToCatalog(attributeGtin.values[0].name, this.account)
        this.elegible = true
      } catch (e) {
        this.elegible = false
      } finally {
        this.loading = false
      }
    },
    methods: {
      async updateAnnouncementToCheckout () {
        this.isUpdating = true
        try {
          const data = {
            itemId: this.product.code,
            idVariation: this.announcementVariation.code,
            catalogProductId: this.announcementToMatch.id
          }
          this.newAnnouncement = await api.mercadoLivre.matchCatalog(data, this.account)
          this.match = true
          notifier.success('Match realizado com sucesso', 'Sucesso')
        } catch (e) {
          notifier.error('Erro ao realizar match', 'Erro')
        } finally {
          this.isUpdating = false
        }
      },
      formatAttributes (attributes) {
        if (!attributes) {
          return []
        }
        return attributes.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1
          }
          return 0
        }).map(attribute => ({
          label: attribute.name,
          value: attribute.value_name
        }))
      },
      redirectToNewAnnouncement () {
        this.$router.push(`/marketplace/mercadoLivre/announcements/${this.newAnnouncement._id.$oid}`)
      }
    },
    computed: {
      announcementVariationName () {
        return this.formatAttributes(this.announcementVariation.attributes)
      },
      productToMatchAttributes () {
        return this.formatAttributes(this.announcementToMatch.attributes)
      }
    },
    components: {
      FormGroup,
      Panel,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: -10px auto 0

  .margin
    margin: 10px 0

  .title
    font-size: 14px
    display: block
    margin-bottom: 10px

  .infos:first-child
    margin-bottom: 20px

  .vertical-center
    display: flex
    align-items: center
    min-height: 51px

  img
    margin-top: 5px

  .img-product
    text-align: center

    img
      max-width: 100%
      margin:  5px 0 16px
      max-height: 150px
      vertical-align: middle

  .btn-container
    align-items: center
    justify-content: center
    display: flex

  .announcement-title
    display: block
</style>



// WEBPACK FOOTER //
// Variation.vue?2e3dfa23